var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.dataState == 'noData')?_c('div',{staticClass:"nodata-containenr"},[_c('img',{staticClass:"nodata-image",style:({'width':_vm.width,'height':_vm.height}),attrs:{"src":require("@/assets/images/nodata.png")}}),_vm._v(" 暂无数据 ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }